<template>
	<div class="card border-0">
		<slot>
		</slot>
	</div>
</template>

<script>

export default {
}

</script>